import { Instrument } from '../../types/shared'
import QuoteModel from '../models/quote'

export function getInstrumentLabel(instrument: Instrument) {
  switch (instrument) {
    case Instrument.Stock:
      return 'Stock'
    case Instrument.Futures:
      return 'Futures'
    case Instrument.Forex:
      return 'Forex'
    case Instrument.Crypto:
      return 'Crypto'
    case Instrument.MarketSentiment:
      return 'Market Sentiment'
  }
}

export function getChartAlt(quoteModel: QuoteModel) {
  return `${quoteModel.name || quoteModel.ticker} - ${getInstrumentLabel(quoteModel.instrument)} Price Chart`
}
